import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import mitt from 'mitt'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'

// 创建mitt事件总线
const emitter = mitt()

// 创建Vue应用
const app = createApp(App)

// 将事件总线添加到全局属性
app.config.globalProperties.emitter = emitter

// 挂载应用
app.use(router)
  .use(store)
  .mount('#app') 